import type { CodeNavYieldState } from './yield-during-work.js';
import { yieldDuringCodeNavWork } from './yield-during-work.js';
import type { SymbolTag } from './types.js';
import { enrichTagsWithModulePaths } from './enrich-tag-module-paths.js';

/** Enrich module path tags in chunks so large files can yield to the event loop. */
export async function enrichTagsWithModulePathsAsync(
  tags: readonly SymbolTag[],
  filePath: string,
  workspaceFiles: ReadonlySet<string>,
  state: CodeNavYieldState,
): Promise<SymbolTag[]> {
  const chunkSize = 64;
  const enriched: SymbolTag[] = [];

  for (let i = 0; i < tags.length; i += chunkSize) {
    await yieldDuringCodeNavWork(state);
    const chunk = tags.slice(i, i + chunkSize);
    enriched.push(...enrichTagsWithModulePaths(chunk, filePath, workspaceFiles));
  }

  return enriched;
}
